module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_BG_formatted.24ecc20c.pdf";